import { render, staticRenderFns } from "./NonMixForm.vue?vue&type=template&id=475d3fa8&scoped=true"
import script from "./NonMixForm.vue?vue&type=script&lang=js"
export * from "./NonMixForm.vue?vue&type=script&lang=js"
import style0 from "./NonMixForm.vue?vue&type=style&index=0&id=475d3fa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475d3fa8",
  null
  
)

export default component.exports